module.exports = __webpack_public_path__ + "img/216.e5749aa7.jpg";